// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir] .card-content[data-v-e0531984] {\n  padding: 1rem;\n}", ""]);
// Exports
module.exports = exports;
